import { queryGraphQL, mutateGraphQL } from 'common/util/query';
import { node, nodeWithArgs, toQuery, toMutation } from 'common/util/queryHelper';
import { addApplicationMessage } from 'common/actions/applicationMessagesActions';
import lodash from 'lodash';

export const WRITE_BINDER_VALIDATION = 'WRITE_BINDER_VALIDATION';
export const LOADING_BINDER_VALIDATION = 'LOADING_BINDER_VALIDATION';
export const LOADED_BINDER_VALIDATION = 'LOADED_BINDER_VALIDATION';
export const UNLOAD_BINDER_VALIDATION = 'UNLOAD_BINDER_VALIDATION';

export const WRITE_BINDER_VALIDATION_DOCUMENT_UPLOAD = 'WRITE_BINDER_VALIDATION_DOCUMENT_UPLOAD';
export const WRITE_BINDER_VALIDATION_DOCUMENT_REQUIREMENT = 'WRITE_BINDER_VALIDATION_DOCUMENT_REQUIREMENT';
export const WRITE_BINDER_VALIDATION_CHECK_STAFF_MEMBERS = 'WRITE_BINDER_VALIDATION_CHECK_STAFF_MEMBERS';
export const WRITE_BINDER_VALIDATION_SYNC_STAFF_MEMBERS = 'WRITE_BINDER_VALIDATION_SYNC_STAFF_MEMBERS';

export function retrieveBinderValidation(binderId, skipLoadingStatus) {
    return async dispatch => {
        if (!skipLoadingStatus) {
            dispatch({type:LOADING_BINDER_VALIDATION});
        }
        const queryNode = nodeWithArgs('validateBinder', {
            binderId
        }, [
            node('documents', [
                'id',
                'name',
                'documentStatus',
                node('documentType', [
                    'id',
                    'displayName'
                ]),
                node('descriptors', [
                    'id',
                    'name',
                    'dataType',
                    'displayName',
                    'values'
                ]),
            ]),
            node('validationValues', [
                'id',
                node('documentType', [
                    'id',
                    'displayName'
                ]),
                'expectedNumOfCopies',
                'descriptorId',
                'descriptorValue',
                'displayOrder',
                'isRequired',
                'validationType',
                'removalDate',
                'syncDate',
            ]),
        ]);

        const response = await queryGraphQL(toQuery(queryNode));
        if (response.errors) {
            dispatch(addApplicationMessage('error', 'An error occurred when loading binder validation'));
        } else {
            const { validateBinder } = response.data;
            dispatch(writeBinderValidation(validateBinder));
            if (!skipLoadingStatus) {
                dispatch({type:LOADED_BINDER_VALIDATION});
            }
        }
    };
}

export function setValidationRequirement(validationId, isRequired) {
    return async dispatch => {
        const queryNode = nodeWithArgs('updateValidationRuleRequirement', {
            id: validationId,
            isRequired
        });

        const response = await mutateGraphQL(toMutation(queryNode));
        const label = isRequired ? 'enable' : 'disable';
        if (response.errors) {
            dispatch(addApplicationMessage('error', `An error occurred while attempting to ${label} document validation.`));
        } else {
            dispatch({type: WRITE_BINDER_VALIDATION_DOCUMENT_REQUIREMENT, payload:{validationId, isRequired}});
        }
    };
}

export function importBinderValidationTemplate(binderId, binderTemplateId) {
    return async dispatch => {
        const queryNode = nodeWithArgs('importValidationRules', {
            binderId,
            binderTemplateId
        });

        const response = await mutateGraphQL(toMutation(queryNode));
        if (response.errors) {
            dispatch(addApplicationMessage('error', 'An error occurred while attempting to import binder validation template.'));
        }
        if(response.data.importValidationRules) {
            dispatch(retrieveBinderValidation(binderId));
        }
    };
}

export function checkBinderValidationStaffMembers(binderId) {
    return async dispatch => {
        const queryNode = nodeWithArgs('checkBinderValidationStaffMembers', {
            binderId
        }, [
            'syncRequired',
            'staffAdded',
            'staffReAdded',
            'staffRemoved'
        ]);

        const response = await queryGraphQL(toQuery(queryNode));
        if (response.errors) {
            dispatch(addApplicationMessage('error', 'An error occurred when loading binder validation'));
        } else {
            dispatch({
                type: WRITE_BINDER_VALIDATION_CHECK_STAFF_MEMBERS,
                payload: response.data.checkBinderValidationStaffMembers
            });
        }
    };
}

export function syncBinderValidationStaffMembers(binderId, binderTemplateId, staffToAdd, staffToReAdd, staffToRemove) {
    return async dispatch => {
        const queryNode = nodeWithArgs('syncBinderValidationStaffMembers', {
            binderId,
            binderTemplateId,
            staffToAdd: lodash.toArray(staffToAdd),
            staffToReAdd: lodash.toArray(staffToReAdd),
            staffToRemove: lodash.toArray(staffToRemove),
        });

        const response = await mutateGraphQL(toMutation(queryNode));
        if (response.errors) {
            dispatch(addApplicationMessage('error', 'An error occurred while attempting to sychronize your validation.'));
        }
        if (response.data.syncBinderValidationStaffMembers) {
            dispatch({type: WRITE_BINDER_VALIDATION_SYNC_STAFF_MEMBERS});
            dispatch(retrieveBinderValidation(binderId));
        }
    };
}

function writeBinderValidation(values) {
    return {
        type: WRITE_BINDER_VALIDATION,
        payload: {
            values
        }
    };
}

export function unloadBinderValidation() {
    return dispatch => dispatch({type: UNLOAD_BINDER_VALIDATION});
}

export function writeUploadedDocument(lastUploadedDocument, documentTypeId) {
    return dispatch => dispatch(
        {
            type: WRITE_BINDER_VALIDATION_DOCUMENT_UPLOAD,
            payload: {
                lastUploadedDocument,
                documentTypeId
            }
        }
    );
}